var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  $("#education-cards-slider__list").slick({
    centerMode: true,
    slidesToShow: 4,
    infinite: true,
    dots: true,
    prevArrow: false,
    lazyLoad: "ondemand",
    nextArrow: false,
    focusOnSelect: true,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });
});
